import { combineReducers } from "redux";
import AuthReducer from "./auth/AuthReducer";
import QuotesReducer from "./quotes/QuotesReducer";
import AgenciesReducer from "./agencies/AgenciesReducer";
import RidesReducer from "./rides/RidesReducer";
// import LoginReducer from "./login/loginReducer"

export default combineReducers({
  auth: AuthReducer,
  quotes: QuotesReducer,
  agencies: AgenciesReducer,
  // Agenciess: AgenciesReducer,
  rides: RidesReducer,
});
